import { get, post, put } from "../config/api";

export const list = async () => await get(`parts`);
export const create = async (props) => await post(`parts`, props);
export const update = async (props) => await put(`parts`, props);

export const options = async (props) => await get(`parts/options`, props);
